import { createStyles, Theme } from '@material-ui/core'

export const searchFilterCardStyle = (theme: Theme) =>
  createStyles({
    card: {
      marginBottom: theme.spacing(2)
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      gap: theme.spacing(1),
      margin: theme.spacing(1)
    }
  })
